import { Component, ContentChildren, Input, QueryList, OnInit, inject } from '@angular/core';

import { TabComponent } from './tab.component';
import { TabStateService } from './tab-state.service';

@Component({
  selector: 'fin-tab-group',
  templateUrl: 'tab-group.component.html',
  providers: [TabStateService],
  standalone: false,
})
export class TabGroupComponent implements OnInit {
  private service = inject(TabStateService);

  @Input()
  tabGroupId: string;

  @ContentChildren(TabComponent)
  tabs: QueryList<TabComponent>;

  ngOnInit(): void {
    this.service.init(this.tabGroupId);
  }
}
